import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseSegmentedControl from './HseSegmentedControl.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseSegmentedControl;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-SegmentedControl",class:( _obj = {}, _obj[("hse-SegmentedControl_size_" + _vm.size)] = _vm.size, _obj ),attrs:{"tabindex":"0"},on:{"keydown":_vm.onKeyDown,"blur":_vm.onBlur}},_vm._l((_vm.items),function(item,key){return _c('HseSegmentedControlItem',{key:key,attrs:{"active":_vm.value === item.value,"disabled":item.disabled,"focus":_vm.state.focusedItemValue === item.value,"inactive":item.inactive,"value":item.value},on:{"click":function($event){return _vm.onItemClick(item.value)}}},[(['function', 'object'].includes(typeof item.label))?[_c(item.label,{tag:"component",attrs:{"item":item}})]:[_vm._v("\n      "+_vm._s(item.label)+"\n    ")]],2)}),1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
